import React from "react";

const Crosshairs = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      height="17px"
      width="17px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 392.663 392.663"
    >
      <g>
        <g>
          <path d="M381.77,185.406h-17.131c-5.43-84.299-73.05-151.919-157.349-157.349V10.925C207.289,4.913,202.44,0,196.364,0    c-6.012,0-10.925,4.848-10.925,10.925v17.131c-84.299,5.43-151.919,73.05-157.349,157.349H10.958    c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925h17.067c5.43,84.299,73.051,151.919,157.35,157.349    v17.131c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925v-17.131    c84.299-5.43,151.919-73.05,157.349-157.349h17.131c6.012,0,10.925-4.848,10.925-10.925    C392.63,190.319,387.782,185.406,381.77,185.406z M185.438,49.972v64.582c-36.784,4.848-66.004,34.069-70.853,70.853H50.004    C55.37,113.196,113.228,55.337,185.438,49.972z M185.438,342.691c-72.275-5.366-130.069-63.16-135.434-135.434h64.582    c4.849,36.784,34.069,66.004,70.853,70.853V342.691z M196.428,230.465c-6.077,0-10.925,4.849-10.925,10.925v14.675    c-24.824-4.461-44.347-24.049-48.808-48.808h14.675c6.012,0,10.925-4.848,10.925-10.925s-4.848-10.925-10.925-10.925h-14.675    c4.461-24.76,24.048-44.283,48.808-48.808v14.675c0,6.012,4.849,10.925,10.925,10.925c6.012,0,10.925-4.849,10.925-10.925v-14.675    c24.76,4.461,44.283,24.049,48.743,48.808h-14.675c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.913,10.925,10.925,10.925    h14.675c-4.461,24.76-24.048,44.283-48.743,48.808V241.39C207.354,235.378,202.505,230.465,196.428,230.465z M207.289,342.691    v-64.582c36.784-4.848,65.939-34.069,70.853-70.853h64.582C337.358,279.467,279.499,337.325,207.289,342.691z M278.141,185.406    c-4.849-36.784-34.069-65.939-70.853-70.853V49.972c72.21,5.366,130.069,63.224,135.434,135.434H278.141z" />
        </g>
      </g>
    </svg>
  );
};

export default Crosshairs;
